var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccordion911Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.623,
    height: 19.623,
    viewBox: "0 0 19.623 19.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-phone-alt",
    "data-name": "Icon awesome-phone-alt",
    d: "M.56,13.867l4.292-1.84a.92.92,0,0,1,1.073.264l1.9,2.323a14.206,14.206,0,0,0,6.791-6.791l-2.323-1.9a.918.918,0,0,1-.264-1.073L13.87.556A.926.926,0,0,1,14.924.024l3.986.92a.92.92,0,0,1,.713.9A17.781,17.781,0,0,1,1.839,19.623a.92.92,0,0,1-.9-.713l-.92-3.986A.931.931,0,0,1,.56,13.867Z",
    transform: "translate(0 0)",
    fill: "#EC6461"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccordion911Icon);
export default __webpack_public_path__ + "static/media/Accordion911Icon.a8c787bfbc83e62d3bc2d7b2be4645d0.svg";
export { ForwardRef as ReactComponent };